import React, { useState } from 'react'
import { DatePicker, Form } from 'antd'

const RangePickerCustom = ({ name, placeholder, rules = [] }) => {
  const [minValue, setMinValue] = useState(null)
  const [maxValue, setMaxValue] = useState(null)

  const disabledMinDate = (current) => {
    if (maxValue) {
      return current && current > maxValue.clone().endOf('day')
    }
    return false
  }

  const disabledMaxDate = (current) => {
    if (minValue) {
      return current && current < minValue.clone().startOf('day')
    }
    return false
  }
  const formatDate = 'DD/MM/YYYY'
  return (
    <div className='input-range-container'>
      <Form.Item label=''>
        <Form.Item
          name={`${name}Min`}
          noStyle
          rules={rules}
        >
          <DatePicker
            bordered={false}
            placeholder={`${placeholder} từ`}
            disabledDate={disabledMinDate}
            onChange={setMinValue}
            format={formatDate}
          />
        </Form.Item>
        <span className='position-relative dash' />
        <Form.Item
          name={`${name}Max`}
          noStyle
          rules={rules}
        >
          <DatePicker
            bordered={false}
            placeholder='Đến'
            disabledDate={disabledMaxDate}
            onChange={setMaxValue}
            format={formatDate}
          />
        </Form.Item>
      </Form.Item>
    </div>
  )
}
export default RangePickerCustom
